import moment from 'moment';
import debounce from 'lodash/debounce';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Range from 'rc-slider/lib/Range';
//import 'rc-slider/dist/rc-slider.min.css';

const dayTicks = 86400000;
const dateFormat = 'YYYY-MM-DD';

const toDateString = (ticks) => {
    return moment(ticks).format(dateFormat);
}

class RangeInput extends Component {

    static propTypes = {
        min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
        step: PropTypes.number,
        label: PropTypes.string,
        onMinChanged: PropTypes.func,
        onMaxChanged: PropTypes.func,
        onAfterChange: PropTypes.func,
        registerRangeReference: PropTypes.func,
        registerYRangeReference: PropTypes.func,
        valueIsDate: PropTypes.bool,
        useDataMax: PropTypes.bool,
        onParentDateRangeChanged: PropTypes.func
    }

    state = {
        currentMin: this.props.values ? this.props.values[0] : this.props.min || 0,
        currentMax: this.props.useDataMax !== true && this.props.values ? this.props.values[1] : this.props.max || 10,
        min: this.props.min,
        max: this.props.max,
        valueIsDate: this.props.valueIsDate
    }

    componentDidMount = () => {
        const { onMinChanged, onMaxChanged } = this.props;
        const { currentMin, currentMax } = this.state;
        if (onMinChanged) {
            onMinChanged(currentMin);
        }

        if (onMaxChanged) {
            onMaxChanged(currentMax);
        }
    }

    adjustInputValue = value => {
        const { valueIsDate } = this.props;
        const val = value || 0;

        return valueIsDate ? toDateString(val) : val;
    }

    adjustValue = value => {
        const { valueIsDate, step } = this.props;
        const val = value || 0;

        if (valueIsDate) {
            return moment.utc(val).startOf("day").valueOf();
        }

        return val;
    }

    dateChanged = (event, isMin) => {
        const value = event.target.value;
        const { onMinChanged, onMaxChanged, valueIsDate } = this.props;

        if (value) {
            const newState = {};
            const preparedValue = valueIsDate ? +moment(value, dateFormat) : +value;
            newState[isMin ? 'currentMin' : 'currentMax'] = preparedValue;
            if (isMin && onMinChanged) {
                onMinChanged(preparedValue);
            }
            if (!isMin && onMaxChanged) {
                onMaxChanged(preparedValue);
            }

            this.fireAfterChange();
            this.setState({ ...this.state, ...newState });
        }
    }

    minChanged = (event) => {
        this.dateChanged(event, true);
    }

    maxChanged = (event) => {
        this.dateChanged(event, false);
    }

    onChange = result => {
        const [newMin, newMax] = result;
        const { onMinChanged, onMaxChanged } = this.props;
        const { currentMin, currentMax } = this.state;

        if (currentMin === newMin && currentMax === newMax) {
            return;
        }

        if (onMinChanged) {
            onMinChanged(newMin);
        }

        if (onMaxChanged) {
            onMaxChanged(newMax);
        }

        this.setState({
            currentMin: newMin,
            currentMax: newMax
        });
    }

    fireAfterChange = debounce(e => {
        const { onAfterChange, onParentDateRangeChanged } = this.props
        const { currentMin, currentMax } = this.state;

        if (onAfterChange) {
            onAfterChange();
        }
        if (onParentDateRangeChanged) {
            onParentDateRangeChanged(currentMin, currentMax)
        }
    }, 200)

    componentWillMount() {

        if (this.props.registerRangeReference) {
            this.props.registerRangeReference(this)
        }
        if (this.props.registerYRangeReference) {
            this.props.registerYRangeReference(this)
        }
    }
    render = () => {
        const { step, values, label, valueIsDate } = this.props;
        const { min, max, currentMin, currentMax } = this.state;
        const [valueMin, valueMax] = values;
        const defaultValue = [this.adjustValue(valueMin), this.adjustValue(valueMax)] || [this.adjustValue(min), this.adjustValue(max)];

        return (
            <div className="RangeInput">
                {label && <label>{label}</label>}
                <div className="range-controls">
                    <input
                        className="form-control"
                        type={valueIsDate ? 'date' : 'number'}
                        min={this.adjustInputValue(min)}
                        max={this.adjustInputValue(currentMax)}
                        value={this.adjustInputValue(currentMin)}
                        onChange={this.minChanged}>
                    </input>
                    <Range
                        min={this.adjustValue(min)}
                        max={this.adjustValue(max)}
                        step={step || dayTicks}
                        defaultValue={defaultValue}
                        value={[this.adjustValue(currentMin), this.adjustValue(currentMax)]}
                        tipFormatter={value => `${value}%`}
                        onChange={this.onChange}
                        onAfterChange={this.fireAfterChange} />
                    <input
                        className="form-control"
                        type={valueIsDate ? 'date' : 'number'}
                        min={this.adjustInputValue(currentMin)}
                        max={this.adjustInputValue(max)}
                        value={this.adjustInputValue(currentMax)}
                        onChange={this.maxChanged}>
                    </input>
                </div>
            </div>);
    }
}

export default RangeInput;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/range-input.js